import { useI18n } from 'vue-i18n'

/***********************************************************************************
 * This composable is responsible for retrieving a global page title via vue-i18n
 * and providing a function that sets the browser's document title accordingly.
 * It ensures consistent, localized page titles throughout the application.
 ***********************************************************************************/
const useDocumentTitle = (): { setDocumentTitle: () => void } => {
  const { t } = useI18n()
  const title = t('global.pageTitle')

  const setDocumentTitle = (): void => {
    document.title = title
  }

  return {
    setDocumentTitle,
  }
}

export default useDocumentTitle
